import PropertyListingDB from './property-listings-db';
import GenericDB from './generic-db';

export default class PropertyProviderDB extends GenericDB {
  constructor(cityName: any, propertyType: any) {
    super(`properties/${cityName}/propertyTypes/${propertyType}/providers`);
  }

  async getCards(name: any, catagory: any) {
    const providers = await super.readAll();
    // console.log(providers)
    // const kitEntries = []
    console.log(providers);

    const kitproviders = Promise.all(providers.map(async (entry: { id: any }) => {
      const kits = new PropertyListingDB(name, catagory, entry.id);
      const subKitEntry = await kits.readAll();
      console.log(entry);
      return subKitEntry;
    }));

    return kitproviders;
  }

  async getLatestCards(name: any, catagory: any) {
    const providers = await super.readAll();
    // console.log(providers)
    // const kitEntries = []

    const kitproviders = Promise.all(providers.map(async (entry: { id: any }) => {
      const kits = new PropertyListingDB(name, catagory, entry.id);
      const subKitEntry = await kits.readAll();
      console.log(subKitEntry);
      return subKitEntry;
    }));

    return kitproviders;
  }
  // Here you can extend UserProductsDB with custom methods
}
